import { apiClient, fileClient } from "@api/axiosClients";

class CustomError extends Error {
    constructor(message, response) {
        super(message);
        this.response = response;
        
        // backward compatibility
        this.status = response?.status || {};;
        this.headers = response?.headers || {};
        this.data = response?.data || {};
    }
}

const baseRequest = async (client, { endpoint, method = "GET", data = null, headers = {}, responseType = 'json', params = {}}) => {
  try {

    if (data && typeof data === "object") {
      endpoint = endpoint.replace(/\{(\w+)\}/g, (match, key) => {
        if (key in data) {
          const value = data[key];
          delete data[key];
          return encodeURIComponent(value);
        }
        return match;
      });
    }
    
    const response = await client({
      url: endpoint,
      method,
      data,
      params,
      headers: { 
        ...client.defaults.headers.common, 
        ...headers, 
      },
      responseType
    });
    return response;
  } catch (error) {
    console.error("Caught error:", error);
    throw error;
  }
};

const processRequest = async (client, options) => {
  try {
    const response = await baseRequest(client, options);
    const result = {
      status: response.status,
      data: response.data,
      headers: response.headers,
    };

    return result;
  } catch (error) {
    throw new CustomError(
        error.message || "Unknown error",
        error.response || {}
    );
  }
};

export const requestWithClient = async (client, options) => 
  processRequest(client, options);

export const requestApi = async (options) => 

  processRequest(apiClient, options);

export const requestFile = async (options) => 
  processRequest(fileClient, options);


// Example Usage:
// requestApi({ endpoint: "users", method: "POST", data: { name: "John" }, headers: { "Custom-Header": "value" } });
// requestFile({ endpoint: "upload", method: "POST", data: fileData, headers: { "X-File-Type": "image/png" } });